import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import {
	CarlineSelect,
	DetalleMotivo,
	InicioEncuesta,
	MultipleCTASelection,
	RatingStars,
} from 'src/components';
import { RadioTextGroup } from 'src/components/inputs/RadioTextGroup';
import { LayoutTemplate } from 'src/feature-app';
import { CTAsSiNo, CTAsSiNoSinRespuesta } from 'src/feature-app/InputsValues';
import { ConfirmacionCem } from 'src/forms/Cem/ConfirmacionCem';
import { FirstStepCEM } from 'src/forms/Cem/FirstStepCEM';
import { Steps } from 'src/types';
import {
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from '../helpers/data';

export const getStepsVentaComerciales = (
	installation: string,
	carline: string,
) => {
	const optionsDatosIncorrectos = [
		{
			label: 'Marca incorrecta',
			value: valueWrongMarca.toString(),
		},
		{
			label: 'Modelo incorrecto',
			value: valueWrongModelo.toString(),
		},
		{
			label: 'Concesionario incorrecto',
			value: valueWrongConcesion.toString(),
		},
		{
			label: 'Persona de contacto incorrecta',
			value: valueWrongPersona.toString(),
		},
	];

	const optionsPruebaConduccion = [
		{
			label: 'Sí y realicé la prueba',
			value: '1',
		},
		{
			label: 'Sí, pero no realicé la prueba',
			value: '2',
		},
		{
			label: 'No, pero estaba interesado/a',
			value: '3',
		},
		{
			label: 'No, y no estaba interesado/a',
			value: '4',
		},
	];

	const optionsUsoVehiculo = [
		{
			label: 'Exclusivamente profesional',
			value: '1',
		},
		{
			label: 'Profesional y particular (mixto)',
			value: '2',
		},
		{
			label: 'Exclusivamente particular',
			value: '3',
		},
		{
			label: 'Sin respuesta',
			value: '9',
		},
	];

	const optionsEnviarConcesion = [
		{
			value: '3',
			label: 'Sí, mis respuestas pueden ser enviadas y analizadas junto a mi nombre y al número de bastidor de mi vehículo, para el alcance descrito anteriormente (el consentimiento puede revocarse en cualquier momento a través de los canales de contacto que se indican a continuación*)',
			info: '*Puedo revocar este consentimiento en cualquier momento sin dar motivos a mi Distribuidor para mis datos personalizados.',
		},
		{
			value: '2',
			label: 'Mis respuestas pueden ser enviadas pero sin mencionar mi nombre (seleccionando esta opción, el Servicio Oficial no podrá ponerse en contacto contigo en relación a tus comentarios), ni bastidor del vehículo.',
			info: 'Seleccionando esta opción, el punto de venta no podrá ponerse en contacto contigo en relación a tus comentarios.',
		},
		{
			value: '0',
			label: 'No, Mis respuestas solo deben ser analizadas de manera anónima (seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos)',
			info: 'Seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos.',
		},
	];

	const optionsPublicarRespuestas = [
		{
			label:
				'Sí, mis respuestas pueden ser publicadas sin mi nombre en la Web Oficial Volkswagen y en la de ' +
				installation,
			value: '1',
		},
		{
			label:
				'No, mis respuestas no pueden ser publicadas en la Web Oficial Volkswagen y en la de ' +
				installation,
			value: '2',
		},
	];

	let index = 0;
	const stepsVenta: Steps[] = [
		{
			fields: <FirstStepCEM />,
			screenIndex: index++,
			name: 'DatosCorrectos',
			alternateTitle: (
				<Text>¿Puedes confirmar que estos datos son correctos?</Text>
			),
			outputs: ['datosCorrectos'],
			outputsText: ['datosCorrectos'],
			trueOrFalseQuestion: true,
		},
		{
			title: (
				<>
					Por favor,{' '}
					<Text bold>¿puedes confirmar qué dato no es correcto?</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsDatosIncorrectos}
							name="datosIncorrectos"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'DatosIncorrectos',
			outputs: ['datosIncorrectos'],
			outputsText: ['datosIncorrectos'],
			ctas: optionsDatosIncorrectos,
		},
		{
			title: <Text bold>¿Compraste tu vehículo en {installation}?</Text>,
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={CTAsSiNo}
							name="confirmacionConcesion"
							nextOnClick
							ctaWidth="81"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'ConfirmacionConcesion',
			outputs: ['confirmacionConcesion'],
			outputsText: ['confirmacionConcesion'],
		},
		{
			title: <Text bold>¿Cuál es el modelo correcto?</Text>,
			fields: (
				<LayoutTemplate
					element={
						<div>
							<CarlineSelect
								isCEMVenta={true}
								useCarline={true}
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'Modelo',
			outputs: ['modelo'],
			outputsText: ['modelo'],
		},
		{
			title: (
				<>
					A continuación,{' '}
					<Text bold>
						indica tu nivel de satisfacción con cada uno de estos
						aspectos relacionados con la compra de tu último
						vehículo.
					</Text>
				</>
			),
			fields: (
				<InicioEncuesta bodyCopy="Valora del 1 al 5, a mayor número de estrellas más satisfacción." />
			),
			screenIndex: index++,
			name: 'Explicacion',
		},
		{
			title: <Text bold>El trato recibido</Text>,
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionTrato"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTrato',
			outputs: ['satisfaccionTrato'],
			outputsText: ['satisfaccionTrato'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionTratoMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
            identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionTratoMotivo',
			outputs: ['satisfaccionTratoMotivo'],
			outputsText: ['satisfaccionTratoMotivo'],
		},
		{
			title: <Text bold>La organización del concesionario</Text>,
			fields: (
				<LayoutTemplate
					element={
						<div style={{ paddingTop: '8px' }}>
							<Text
								appearance={TokenTextAppearance.copy200}
								staticSize
							>
								A la hora de establecer una cita o entregarte el
								vehículo, por ejemplo.
							</Text>
							<RatingStars
								name="satisfaccionOrganizacion"
								nextOnClick={true}
								textGood="satisfecho/a"
								textBad="insatisfecho/a"
								CTASinRespuesta
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionOrganizacion',
			outputs: ['satisfaccionOrganizacion'],
			outputsText: ['satisfaccionOrganizacion'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionOrganizacionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
            identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionOrganizacionMotivo',
			outputs: ['satisfaccionOrganizacionMotivo'],
			outputsText: ['satisfaccionOrganizacionMotivo'],
		},
		{
			title: (
				<Text bold>
					El asesoramiento recibido por parte del asesor comercial
					Volkswagen Vehículos Comerciales
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionAsesor"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionAsesor',
			outputs: ['satisfaccionAsesor'],
			outputsText: ['satisfaccionAsesor'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionAsesorMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
            identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionAsesorMotivo',
			outputs: ['satisfaccionAsesorMotivo'],
			outputsText: ['satisfaccionAsesorMotivo'],
		},
		{
			title: (
				<Text bold>
					¿Cuál es tu nivel de satisfacción con nuestros servicios
					prestados como concesionario?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<div style={{ paddingTop: '8px' }}>
							<Text
								appearance={TokenTextAppearance.copy200}
								staticSize
							>
								Pensando en el proceso de compra en general de
								tu nuevo vehículo.
							</Text>
							<RatingStars
								name="satisfaccionConcesion"
								nextOnClick={true}
								textGood="satisfecho/a"
								textBad="insatisfecho/a"
								CTASinRespuesta
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionConcesion',
			outputs: ['satisfaccionConcesion'],
			outputsText: ['satisfaccionConcesion'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionConcesionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
            identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionConcesionMotivo',
			outputs: ['satisfaccionConcesionMotivo'],
			outputsText: ['satisfaccionConcesionMotivo'],
		},
		{
			title: (
				<Text bold>
					¿Hay algún aspecto con el que no estuvieras satisfecho y que
					no hayas mencionado aún?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="aspectoSatisfaccionMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan
            identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'AspectoSatisfaccionMotivo',
			outputs: ['aspectoSatisfaccionMotivo'],
			outputsText: ['aspectoSatisfaccionMotivo'],
		},
		{
			title: (
				<Text bold>
					¿El asesor comercial te ofreció realizar una prueba de
					conducción?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsPruebaConduccion}
							name="testDrive"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'TestDrive',
			outputs: ['testDrive'],
			outputsText: ['testDrive'],
			ctas: optionsPruebaConduccion,
		},
		{
			title: (
				<>
					<Text bold>
						¿Te ha contactado {installation} para preguntarte si
						estás satisfecho con tu {carline} después de
						entregártelo?
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={CTAsSiNoSinRespuesta}
							name="satisfaccionContacto"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionContacto',
			outputs: ['satisfaccionContacto'],
			outputsText: ['satisfaccionContacto'],
			trueOrFalseQuestion: true,
			ctas: CTAsSiNoSinRespuesta,
		},
		{
			title: <Text bold>El uso que hace de su vehículo es...</Text>,
			fields: (
				<LayoutTemplate
					element={
						<MultipleCTASelection
							ctaValues={optionsUsoVehiculo}
							name="usoVehiculo"
							nextOnClick
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'UsoVehiculo',
			outputs: ['usoVehiculo'],
			outputsText: ['usoVehiculo'],
			ctas: optionsUsoVehiculo,
		},
		{
			title: (
				<>
					<Text bold>Pensando en tu actual {carline},</Text> ¿cuál es
					tu nivel de satisfacción?
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name="satisfaccionVehiculo"
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionVehiculo',
			outputs: ['satisfaccionVehiculo'],
			outputsText: ['satisfaccionVehiculo'],
			outputsIsStars: true,
		},
		{
			title: (
				<Text bold>
					¿Cuál es la razón por la que has dado esta puntuación?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name="satisfaccionVehiculoMotivo"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'SatisfaccionVehiculoMotivo',
			outputs: ['satisfaccionVehiculoMotivo'],
			outputsText: ['satisfaccionVehiculoMotivo'],
		},
		{
			title: (
				<>
					Finalmente nos gustaría saber si podemos{' '}
					<Text bold>
						enviar tus respuestas junto con tu nombre al
						concesionario {installation} y el bastidor del vehículo,
						y puedan usarlos para análisis adicionales.
					</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<RadioTextGroup
							name="enviarConcesion"
							options={optionsEnviarConcesion}
						/>
					}
				/>
			),
			screenIndex: index++,
			name: 'EnviarConcesion',
			outputs: ['enviarConcesion'],
			outputsText: ['enviarConcesion'],
			ctas: optionsEnviarConcesion,
		},
		{
			title: (
				<Text bold>
					¿Podríamos publicar tus respuestas en la web oficial de
					Volkswagen Vehículos Comerciales y en la de {installation}{' '}
					sin mencionar tu nombre?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<div style={{ paddingTop: '8px' }}>
							<Text
								appearance={TokenTextAppearance.copy200}
								staticSize
							>
								Para compartir tu experiencia con otros
								clientes.
							</Text>
							<RadioTextGroup
								name="publicarRespuestas"
								options={optionsPublicarRespuestas}
							/>
						</div>
					}
				/>
			),
			screenIndex: index++,
			name: 'PublicarRespuestas',
			outputs: ['publicarRespuestas'],
			outputsText: ['publicarRespuestas'],
			ctas: optionsPublicarRespuestas,
		},
		{
			fields: <ConfirmacionCem />,
			screenIndex: index++,
			name: 'Confirmacion',
			outputs: ['confirmacion'],
			outputsText: ['confirmacion'],
		},
	];

	return stepsVenta;
};
